import { AxiosResponse } from "axios";
import AutomatModellResult from "../interface/AutomatModell";
import { KaufanfrageSucheResult } from "../interface/Kaufanfrage";
import KaufanfrageStatusResult from "../interface/KaufanfrageStatus";

const KaufanfragenDTO = {
  convertKaufanfragenResponse: (response: AxiosResponse): KaufanfrageSucheResult => {
    if (response.data) {
      return {
        Row: response.data.Row,
        total: response.data.total,
      };
    }
    return { Row: [], total: 0 };
  },
  convertKaufanfragenStatusResponse: (
    response: AxiosResponse
  ): KaufanfrageStatusResult => {
    if (response.data) {
      return {
        Row: response.data.Row,
        total: response.data.total,
      };
    }
    return { Row: [], total: 0 };
  },
  convertModellResponse: (response: AxiosResponse): AutomatModellResult => {
    if (response.data) {
      return {
        Row: response.data.Row,
        total: response.data.total,
      };
    }
    return { Row: [], total: 0 };
  },
};
export default KaufanfragenDTO;
